import { Button, H2 } from "@sellar-io/components";
import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";
import { SellarCreditTwoDialogPageEnum } from "../types/SellarCreditTwoDialogPageEnum";
import { SellarCreditTwoDialogPage } from "./SellarCreditTwoDialogPage";

export const TwoAccountVerificationIntro = () => {
  const { setPage } = useFullPageDialogContext();

  return (
    <SellarCreditTwoDialogPage contentClassName="justify-center">
      <div className="flex flex-col items-center gap-16">
        <div className="flex flex-col items-center gap-2">
          <img
            src="https://sellar.imgix.net/sellar-image-assets/app-assets/sellarxtwo.svg"
            className="my-4 w-[320px] shrink-0"
          />
          <div className="flex flex-col gap-4 py-8">
            <H2>
              You’ll be applying for credit with our financial partner, Two Inc
            </H2>
            <p>
              We’ve partnered up with Trade Credit provider Two Inc to make
              Sellar Credit possible. You will need to verify your account in
              their portal before you are returned to Sellar
            </p>
          </div>
        </div>

        <div className="w-full">
          <Button
            className="w-full"
            onClick={() => {
              setPage(
                SellarCreditTwoDialogPageEnum.TWO_ACCOUNT_VERIFICATION_GET_STARTED,
              );
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </SellarCreditTwoDialogPage>
  );
};
